<template>
  <div>
    <div class="content">
      <template v-for="(itemType, index) of showSelect">
        <!-- 时间筛选 -->
        <template v-if="itemType === 400">
          <a-radio-group :key="itemType" v-model="dateWeek" button-style="solid" @change="changeDateWeek">
            <a-radio-button value="nearWeek">最近1周</a-radio-button>
            <a-radio-button value="nearHalfMonth">最近2周</a-radio-button>
            <a-radio-button value="nearMonth">最近1月</a-radio-button>
          </a-radio-group>
          <div class="list">
            <span>年度：</span>
            <a-select
              placeholder="请选择年度"
              style="width: 120px"
              @change="yearChange"
              v-model="yearData"
              :allowClear="true"
            >
              <a-select-option :value="item" v-for="item of yearArr" :key="item">
                {{ item }}
              </a-select-option>
            </a-select>
            <a-select
              placeholder="请选择本年度学期"
              style="width: 120px; margin-left: 10px"
              @change="semesterChange"
              v-model="semesterData"
              :allowClear="true"
            >
              <a-select-option :value="item.value" v-for="item of semesterArr" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-range-picker
              v-model="date"
              :disabledDate="disabledDate"
              @change="changeDateCustom"
              :format="dateFormat"
              class="screen-picker"
              style="margin-left: 10px"
            />
          </div>
        </template>
        <!-- 基础筛选 -->
        <!-- 学校年级 -->
        <!-- <div class="list" v-if="itemType === 1" :key="index">
          <span>学校年级：</span>
          <a-select
            placeholder="请选择年级"
            style="width: 120px"
            @change="handleChange"
            v-model="selectData.grade_id"
            :allowClear="true"
          >
            <a-select-option :value="item.id" v-for="item of selectBaseData.school_grade" :key="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </div> -->
        <!-- 课件专业 -->
        <div class="list" v-if="itemType === 2" :key="index">
          <span>课件专业：</span>
          <a-select
            placeholder="请选择专业"
            style="width: 120px"
            @change="handleChange"
            v-model="selectData.subject_id"
            :allowClear="true"
          >
            <a-select-option :value="item.id" v-for="item of selectBaseData.res_subject" :key="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </div>
        <!-- 成绩等级 -->
        <div class="list" v-if="itemType === 3" :key="index">
          <span>成绩等级：</span>
          <a-select
            placeholder="请选择成绩等级"
            style="width: 120px"
            @change="handleChange"
            v-model="selectData.result_level"
          >
            <a-select-option :value="item.id" v-for="item of selectBaseData.result_level" :key="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </div>

        <!-- 特别筛选 -->
        <!-- 学校列表 -->
        <div class="list" v-if="itemType === 101" :key="index">
          <span>学校：</span>
          <a-select
            placeholder="请选择学校"
            style="width: 120px"
            @change="handleChange"
            mode="multiple"
            v-model="selectData.school_id"
          >
            <a-select-option :value="item.id" v-for="item of selectSchoolData" :key="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </div>
        <!-- 实验步骤 -->
        <div class="list" v-if="itemType === 102" :key="index">
          <span>实验步骤：</span>
          <a-select placeholder="请选择专业" style="width: 120px" @change="handleChange">
            <a-select-option value="jack"> 九年级 </a-select-option>
            <a-select-option value="lucy"> 十年级 </a-select-option>
          </a-select>
        </div>
        <!-- 班级学生 -->
        <div class="list" v-if="itemType === 103" :key="index">
          <span>班级学生：</span>
          <a-select
            placeholder="请选择学生"
            style="width: 120px"
            @change="handleChange"
            v-model="selectData.sutdent_id"
            mode="multiple"
          >
            <a-select-option :value="item.id" v-for="item of studentData" :key="item">{{ item.name }}</a-select-option>
          </a-select>
        </div>

        <!-- 联动筛选 -->
        <!-- 课件名称 -->
        <div class="list" v-if="itemType === 201" :key="index">
          <span>课件名称：</span>
          <a-cascader
            :options="options"
            :load-data="loadData"
            :placeholder="selectDefault.resPlaceholder"
            change-on-select
            @change="onChange"
            :fieldNames="fieldNames"
          />
        </div>
        <!-- 学校班级 -->
        <div class="list" v-if="itemType === 202" :key="index">
          <span>学校班级：</span>
          <a-cascader
            :options="schoolClassData"
            :placeholder="selectDefault.classPlaceholder"
            @change="onChangeClass"
            :fieldNames="fieldNames"
            :allowClear="true"
          />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  data() {
    return {
      dateFormat: 'YYYY-MM-DD',
      date: [],
      dateWeek: '',
      yearArr: [],
      yearData: undefined,
      schoolClassData: [],
      semesterArr: [
        {
          name: '上学期',
          value: 1
        },
        {
          name: '下学期',
          value: 2
        }
      ],
      semesterData: undefined,
      selectData: {
        subject_id: '14',
        result_level: 1
      },
      selectDefault: {
        resPlaceholder: '选择课件',
        rid: '',
        classPlaceholder: '选择班级',
        class_id: '',
        canChange: true
      },
      fieldNames: { label: 'name', value: 'id', children: 'children' },
      options: [
        {
          value: 'zhejiang',
          label: 'Zhejiang',
          isLeaf: true
        },
        {
          value: 'jiangsu',
          label: 'Jiangsu',
          isLeaf: false
        }
      ],
      studentData: [],
      selectSchoolData: [],
      selectBaseData: {}
    }
  },
  props: {
    showSelect: {
      type: Array,
      default: () => {
        return [400, 1]
      }
    },
    dataTrigger: {
      type: Number,
      default: 0
    },
    selectDefaultProp: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    // console.log('dateInit1', this.dataTrigger)
  },
  mounted() {
    // console.log('子模块初始化')
    // this.dateWeek = 'nearWeek'
    // const date = []
    // date[0] = this.funDate(-6)
    // date[1] = this.funDate(0)
    // this.date = date
    // this.selectData.date = this.date
    // console.log(this.showSelect)
    // console.log('dateInit2', this.dataTrigger)
    if (this.dataTrigger === 1) {
      this.getData()
    }
    this.initYear()
    this.init()
  },
  methods: {
    // 触发
    handleChange() {
      this.getData()
    },
    // 课件选择
    onChange(value) {
      // if (value.length === 2) {
      //   this.selectData.rid = value[1]
      //   this.getData()
      // }
    },
    // 班级选择
    onChangeClass(value) {
      if (value.length === 2) {
        this.selectData.class_id = value[1]
        this.getData()
        this.$emit('sendClassData', {
          all: this.schoolClassData,
          select: value[0]
        })
        this.getStudentData()
      }
    },
    getStudentData() {
      const data = {
        type: 'student',
        class_id: this.selectData.class_id
      }
      selectSchoolStudent(data).then(res => {
        this.studentData = res.data
        this.$emit('sendStudentData', this.studentData)
      })
    },
    loadData(selectedOptions) {
      console.log(selectedOptions)
      // if (selectedOptions.length == 2) return
      const targetOption = selectedOptions[selectedOptions.length - 1]
      const res = {
        s: 200,
        msg: 'success',
        process_time: 46,
        data: [
          {
            id: '14',
            name: '电机与电器'
          },
          {
            id: '15',
            name: '电力系统及其自动化'
          },
          {
            id: '16',
            name: '高电压与绝缘技术'
          }
        ]
      }
      res.data.forEach(item => {
        item.isLeaf = true
        item.type = targetOption.type === ''
      })
      targetOption.children = res.data
      this.options = [...this.options]
    },

    // 初始化日期
    dateInit() {
      this.dateWeek = 'nearWeek'
      const date = []
      date[0] = this.funDate(-6)
      date[1] = this.funDate(0)
      this.date = date
    },
    yearChange(val) {
      const date = []
      if (this.semesterData === 1) {
        date[0] = this.yearData + '-09-01'
        date[1] = this.yearData + 1 + '-02-15'
        this.date = date
        this.dateWeek = ''
      } else if (this.semesterData === 2) {
        date[0] = this.yearData + 1 + '-03-01'
        date[1] = this.yearData + 1 + '-07-31'
        this.date = date
        this.dateWeek = ''
      } else if (this.semesterData === undefined) {
        // 未选择学期不做处理
      }
    },
    semesterChange(val) {
      // console.log(val, this.yearData)
      const date = []
      if (this.yearData === undefined) {
        return
      }
      if (val === 1) {
        date[0] = this.yearData + '-09-01'
        date[1] = this.yearData + 1 + '-02-15'
      } else if (val === 2) {
        date[0] = this.yearData + 1 + '-03-01'
        date[1] = this.yearData + 1 + '-07-31'
      }
      this.dateWeek = ''
      this.date = date
    },
    initYear() {
      const year = moment().year()
      const month = moment().month()
      if (month > 6) {
        this.yearArr = [year, year - 1, year - 2, year - 3, year - 4]
      } else {
        this.yearArr = [year - 1, year - 2, year - 3, year - 4, year - 5]
        // this.yearData = year - 1
      }
    },
    changeDateWeek(event) {
      const value = event.target.value
      const date = []
      date[1] = this.funDate(0)
      if (value === 'nearWeek') {
        date[0] = this.funDate(-6)
      } else if (value === 'nearHalfMonth') {
        date[0] = this.funDate(-14)
      } else {
        date[0] = this.funDate(-30)
      }
      // console.log(date)
      this.date = date
      // console.log(this.date)
    },
    // 使用时间日期选择回调
    changeDateCustom(date, dateString) {
      // console.log(date, dateString)
      this.date[0] = dateString[0]
      this.date[1] = dateString[1]
      this.selectData.date = this.date
      // 取消快捷日期选择
      this.dateWeek = ''
    },
    funDate(num) {
      const time = moment(
        moment()
          .add(num, 'day')
          .toDate()
      ).format('YYYY-MM-DD')
      return time
    },
    disabledDate(current) {
      // Can not select days before today and today
      // return current && current < moment().endOf('day')
    },

    init() {
      const obj = this.showSelect
      // console.log('监听到data')
      if (obj.indexOf(1) > -1 || obj.indexOf(2) > -1 || obj.indexOf(3) > -1) {
        this.selectBaseData = {
          res_subject: [
            {
              id: '14',
              name: '电气工程'
            },
          ],
          school_grade: [
            {
              id: '18',
              name: '九年级'
            },
            {
              id: '17',
              name: '八年级'
            },
            {
              id: '16',
              name: '七年级'
            },
            {
              id: '29',
              name: '六年级'
            },
            {
              id: '28',
              name: '五年级'
            },
            {
              id: '27',
              name: '四年级'
            },
            {
              id: '26',
              name: '三年级'
            },
            {
              id: '25',
              name: '二年级'
            },
            {
              id: '24',
              name: '一年级'
            }
          ],
          result_level: [
            {
              id: 1,
              value: 1,
              name: '优秀率'
            },
            {
              id: 2,
              value: 2,
              name: '良好率'
            },
            {
              id: 3,
              value: 3,
              name: '及格率'
            },
            {
              id: 4,
              value: 4,
              name: '不及格率'
            }
          ]
        }
      }
      if (obj.indexOf(101) > -1) {
        this.selectSchoolData = [
          {
            id: '18',
            name: '电机工程',
            children: [
              {
                id: '214',
                name: '电机一班'
              },
              {
                id: '215',
                name: '电机二班'
              },
              {
                id: '216',
                name: '电机三班'
              },
              {
                id: '217',
                name: '电机四班'
              },
              {
                id: '218',
                name: '电机五班'
              },
              {
                id: '219',
                name: '电机六班'
              }
            ]
          },
        ]
      }
      if (obj.indexOf(102) > -1) {
        selectReviewSteps().then(res => {
          this.reviewStepsData = res.data
        })
      }
      if (obj.indexOf(201) > -1) {
        const data = {
          type: 'subject'
        }
        const res = {
          s: 200,
          msg: 'success',
          process_time: 46,
          data: [
            {
              id: '14',
              name: '电气工程'
            },
          ]
        }
        res.data.forEach(item => {
          item.isLeaf = false
          item.type = 'grade'
        })
        this.options = res.data
      }
      if (obj.indexOf(202) > -1) {
        this.schoolClassData = [
          {
            id: '18',
            name: '电机工程',
            children: [
              {
                id: '214',
                name: '电机一班'
              },
              {
                id: '215',
                name: '电机二班'
              },
              {
                id: '216',
                name: '电机三班'
              },
              {
                id: '217',
                name: '电机四班'
              },
              {
                id: '218',
                name: '电机五班'
              },
              {
                id: '219',
                name: '电机六班'
              }
            ]
          },
        ]
      }
      if (obj.indexOf(400) > -1) {
        // console.log(11111, this.date, this)
        this.dateInit()
        // this.changeDateWeek({
        //   target: {
        //     value: 'nearWeek'
        //   }
        // })
        // this.date2Init()
        // this.selectData({
        //   date: this.date
        // })
        // this.getData()
      }
      // console.log('000', this.schoolClassData)
    },
    getData() {
      this.selectData.class_id = this.selectData.class_id || this.selectDefault.class_id
      this.selectData.rid = this.selectData.rid || this.selectDefault.rid
      this.$emit('dateChange', this.selectData)
    }
  },
  watch: {
    selectDefaultProp(obj) {
      if (this.selectDefault.canChange) {
        this.selectDefault.canChange = false
        Object.assign(this.selectDefault, obj)
      }
    },
    date(obj) {
      // console.log('date')
      this.selectData.date = this.date
      this.getData()
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px;
  > div,
  > span {
    margin-right: 20px;
    margin-bottom: 20px;
  }
  .list {
    display: flex;
    align-items: center;
  }
}
</style>
